<template>
    <div class="authorCenter" :style="isshowlogin?'height:100vh;overflow:hidden':''">
        <Header :isbig="true" @changeLogin="changeLogin"></Header>
        <div class="authorBox flexible createBox">
            <div class="left">
                <div class="upload-cover">
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img v-if="form.iconTempFile == ''" src="@/assets/author/img-no.png">
                            <img v-if="form.iconTempFile != ''" :src="form.iconTempFile">
                        </div>
                        <input type="file" name="file" @change="uploadFun" class="el-upload-input" accept="image/jpg,image/png">
                    </div>
                    <div class="f14 font-MT f-tac text-fff mt20">{{$lang('create.size')}}</div>
                    <div class="f14 font-MT f-tac text-fff mt5">{{$lang('create.file')}}</div>
                    <div class="avatar-uploader upload-btn-info mt20">
                        <div class="el-upload el-upload--text">
                            <el-button class="upload-btn f16 font-MT" size="medium">{{$lang('create.upload')}}</el-button>
                            <input type="file" name="file" @change="uploadFun" class="el-upload-input" accept="image/jpg,image/png">
                        </div>
                    </div>
                </div>
            </div>
            <div class="right flex mb30">
                <div class="page-title font-MT flexible jc-between aItem-center">
                    <span class="page-name text-fff">{{$lang('create.title')}}</span>
                    <span class="page-btn text-theme f16 f-csp" v-if="bookId == '0'"  @click="createFun()">{{$lang('create.skip')}}</span>
                </div>
                <el-form :model="form" ref="form" class="create-form" :rules="this.$route.params.id != '0'?rules:{}" :inline-message="true">
                    <el-form-item :label="$lang('create.bookTitle')" prop="name">
                        <el-input :placeholder="$lang('create.bookTitlePlace')" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$lang('create.genre')" prop="sort">
                        <el-select
                                style="width: 100%;"
                                v-model="form.sort"
                                :placeholder="$lang('create.genrePlace')">
                            <el-option
                                    v-for="item in genreList"
                                    :label="item.desc"
                                    :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="neId">
                        <span slot="label">
                          <i v-if="bookId == '0'" style="font-style:normal;color: #ff0000">*</i>
                          {{$lang('create.editor')}}
                        </span>
                        <el-select
                        v-model="form.neId"
                        style="width: 100%"
                        :placeholder="$lang('create.editorPlace')"
                        @change="selectEditor"
                        >
                            <el-option
                            v-for="(item, index) in editorsList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$lang('create.contractType')" prop="first">
                        <el-select
                                style="width: 100%;"
                                v-model="form.first"
                                placeholder="Please Select Genre">
                            <el-option
                                    :label="$lang('authorCenter.stories.dujia')"
                                    :value="1"
                            >
                                {{$lang('authorCenter.stories.dujia')}}
                            </el-option>
                            <el-option
                                    :label="$lang('authorCenter.stories.feidujia')"
                                    :value="0"
                            >
                                {{$lang('authorCenter.stories.feidujia')}}
                            </el-option>
                            <el-option
                                    :label="$lang('buyOut.title')"
                                    :value="2"
                            >
                                {{$lang('buyOut.title')}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$lang('create.targetAudience')" prop="classify">
                        <el-radio-group class="m-l-0 m-b-0" v-model="form.classify">
                            <el-radio label="FEMALE">{{$lang('create.girl')}}</el-radio>
                            <el-radio label="MALE">{{$lang('create.boy')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$lang('create.synopsis')" prop="introduce">
                        <el-input :placeholder="$lang('create.description')" v-model='form.introduce' type="textarea" rows="6"></el-input>
                        <div class="f12 font-MT text-info">{{$lang('create.descriptionInfo')}}</div>
                    </el-form-item>
                    <el-form-item :label="$lang('create.tags')" prop="tags">
                        <el-select
                                :placeholder="$lang('create.tagsPlace')"
                                v-model="form.tags" multiple :multiple-limit="5" style="width: 100%;">
                            <el-option
                                    v-for="(item,indnx) in taglists"
                                    :key="indnx"
                                    :label="item"
                                    :value="item"
                            >
                            </el-option>
                        </el-select>
<!--                        <div class="f12 text-info font-MT">{{$lang('create.tagsTips')}}</div>-->
                    </el-form-item>
                    <el-form-item>
                        <el-button round class="create-btn f16 font-MT mt20" size="medium" @click="$event.currentTarget.disabled ? '' : createFun()" v-preventReClick>{{bookId != '0'?$lang('create.edit').toUpperCase():$lang('header.create').toUpperCase()}}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <Login v-if="isshowlogin" @changeLogin="changeLogin" @createFun="createFun"></Login>
    </div>
</template>

<script>
import { isWords } from "utils/core/kernel";
import {sortList, addbook, tagslist, getbookinfo, editbook, getEditorsList} from "apiurl/author";
import baseURL from "@/api/env.js";
import { getToken } from "utils/storage";
import index from '@/mixins/index'
import {hideLoading, showLoading} from "../utils/load";
export default {
    name: "",
    data () {
        var isnamewords = (rule, value, callback) => {
            if (isWords(value) > 30) {
                callback(new Error(this.$lang('authorCenter.stories.newChapterPlace[2]')));
            } else {
                callback();
            }
        };
        var isintrwords = (rule, value, callback) => {
            console.log(isWords(value))
            if (isWords(value) <= 30) {
                callback(new Error(this.$lang('authorCenter.stories.newChapterPlace[3]')));
            } else {
                callback();
            }
        };
        var istags = (rule, value, callback) => {
            console.log(value)
            if (value.length < 3) {
                callback(new Error(this.$lang('create.tagsPlace')));
            } else {
                callback();
            }
        };
        return{
            bookId: '',
            /*添加*/
            form: {
                name: "",
                extendRecommend: "",
                first: 1,
                iconTempFile: "",
                introduce: "",
                publication: false,
                sort: "",
                tags: "",
                neId: '',
                neName: '',
                classify: 'FEMALE',
            },
            rules: {
                name: [
                    { required: true, message: " ", trigger: "blur" },
                    { validator: isnamewords, trigger: "blur" },
                ],
                first: [
                    { required: true, message: " ", trigger: "blur" },
                ],
                neId: [
                    { required: true, message: " ", trigger: "change" },
                ],
                sort: [
                    { required: true, message: " ", trigger: "blur" },
                ],
                introduce: [
                    { required: true, message: " ", trigger: "blur" },
                    { validator: isintrwords, trigger: "blur" },
                ],
                classify: [
                    { required: true, message: "", trigger: "blur" },
                ],
                tags: [
                    { required: true, message: " ", trigger: "blur" },
                    { validator: istags, trigger: "blur" },
                ]
            },
            firstList: [
                { value: true, label: "首发" },
                { value: false, label: "非首发" }
            ], //首发
            publicationList: [
                { value: false, label: "未出版" },
                { value: true, label: "已出版" }
            ], //是否出版
            genreList: [],
            taglists: [],
            /*上传图片*/
            uploadurl: '',
            saveFlag: false,
            editorsList: [],
        }
    },
    watch: {
        '$route': { // $route可以用引号，也可以不用引号  监听的对象
            handler(to, from){
                console.log(111)
                if (this.$route.params.id == '0') {
                   this.form={
                        name: "",
                        extendRecommend: "",
                        first: 1,
                        iconTempFile: "",
                        introduce: "",
                        publication: false,
                        sort: "",
                        tags: "",
                        neId: '',
                        neName: '',
                        classify: 'FEMALE',
                    }
                }
            },
            deep: true, // 深度观察监听 设置为 true
            immediate: true, // 第一次初始化渲染就可以监听到
        }
    },
    created() {
        this.bookId = this.$route.params.id
    },
    mounted() {
        this.getsortlist()
        this.gettags();
        this.reqGetEditorsList();
        if (this.bookId !== '0') {
            this.getbookInfo()
        }
        console.log(this.form)
    },
    mixins: [index],
    methods: {
        selectEditor(value) {
            let obj = this.editorsList.find(item => item.id == value);
            this.form.neName = obj.name;
        },
        /*修改获取信息*/
        async getbookInfo () {
            let res = await getbookinfo(this.bookId);
            if (res.success) {
                this.form = {
                    name: res.data.iname,
                    extendRecommend: res.data.iextendRecommend,
                    first: res.data.ifirst,
                    neName: res.data.neName,
                    neId: +res.data.neId,
                    iconTempFile: res.data.iconUrl,
                    introduce: res.data.iintroduce,
                    publication: res.data.ipublication,
                    sort: res.data.isort == 0?'':res.data.isort,
                    tags: res.data.itags != ''?res.data.itags.split(','):[],
                    classify: res.data.classify,
                };
            }
        },
        async reqGetEditorsList() {
            try {
              let res = await getEditorsList();
              this.editorsList = res.data;
            } catch (error) {
              console.log(error, 'error');
            };
        },
        /* 获取分类 */
        async getsortlist() {
            let res = await sortList();
            if (res.success) {
                this.genreList = res.data;
            }
        },
        // 获取tags
        async gettags() {
            let res = await tagslist();
            if (res.success) {
                this.taglists = res.data;
            }
        },
        /*****上传图片*********/
        uploadFun (e, code) {
            if (!getToken()) {
                this.isshowlogin = true
                return  false
            } else if (e.target.files.length == 0) {
                this.$faild('custom','请选择要上传的图片')
                return false
            }
            let file = e.target.files[0];
            // this.form.iconTempFile = window.URL.createObjectURL(e.target.files[0]);
            // 上传图片地址
            this.uploadurl = `${baseURL.AHEAD}/book/book/add/icon`;
            let fileFormData = new FormData();
            fileFormData.append("file", file);
            showLoading()
            this.uploadImgFun('post',this.uploadurl, fileFormData).then(res=>{
                hideLoading()
                if (res.success) {
                    this.form.iconTempFile = res.data
                } else {
                    this.$faild('operation')
                }
            })
        },
        /*****保存*****/
        createFun () {
            if (!getToken()) {
                this.isshowlogin = true
                return false
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.form.tags = this.form.tags?this.form.tags.join(','):''
                    if (this.bookId != '0') {
                        editbook(this.form, this.bookId)
                            .then(res => {
                                if (res.success) {
                                    this.saveFlag = true
                                    this.$router.push('/author')
                                } else {
                                    this.form.tags = this.form.tags?arrFun(this.form.tags , 'string'):''
                                }
                            })
                            .catch(() => {});
                    } else {
                        addbook(this.qs.stringify(this.form))
                            .then(res => {
                                if (res.success) {
                                    this.saveFlag = true
                                    this.$router.push('/author')
                                } else {
                                    this.form.tags = this.form.tags?arrFun(this.form.tags , 'string'):''
                                }
                            })
                            .catch(() => {});
                    }
                    function arrFun(data, flag) {
                        let arrN = []
                        let arr = data
                        let bv = arr.split(',')
                        if (flag == 'num') {
                            bv.forEach(item => {
                                arrN.push(+item);
                            });
                        } else {
                            arrN = bv
                        }
                        return arrN
                    }
                }
            })
        },

    }
    // beforeRouteLeave(to, from, next) {
    //     let that = this;
    //     let a = window.confirm(that.$lang('create.leavinglost'));
    //     if (a) {
    //         next();
    //     } else {
    //         next(false);
    //     }
    // },
}
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
</style>
